/* eslint-disable no-continue */
import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";
import {withRouter, Redirect, Route, Switch} from 'react-router-dom';
import DealerRankingsSidebar from "./DealerRankingsSidebar";
import DealerRanking from "./DealerRanking";
import {slugifyUrl} from "../../helpers/filters";
import './DealerRankings.scss';

const getRoutes = (match, dealers) => {
    const routes = [];

    // eslint-disable-next-line no-restricted-syntax
    for(const dealer of dealers) {

        let firstValidPath = {};

        // eslint-disable-next-line no-restricted-syntax
        for(const item of dealer.links) {

            // Ensure that URL starts with /node/ so that an ID can be extracted
            if (!item.url || !item.url.internalPath || !item.url.internalPath.includes('/node/')) continue;
            if (!Object.keys(firstValidPath).length) firstValidPath = item;

            routes.push(
                <Route key={item.url.path}
                       exact path={item.url.path}
                       render={() => (
                           <DealerRanking item={item}/>
                       )} />
            );
        }

        // Add Base Route to redirect to first actual route
        if (firstValidPath && firstValidPath.label) {
            routes.push(
                <Route key={`${match.path}/${slugifyUrl(dealer.label)}`} exact path={`${match.path}/${slugifyUrl(dealer.label)}`} component={() => (
                    <Redirect from={`${match.path}/${slugifyUrl(dealer.label)}`}
                              to={firstValidPath.url.path} />
                )} />
            );
        }

    }

    // Ensure that landing on / will direct the user to a usable page
    routes.push(<Route key={`${match.path}`} path={`${match.path}`} exact component={() => (
        <Redirect from={match.path} to={`${match.path}/${slugifyUrl(dealers[0].label)}`} />
    )}/>);

    return routes;
};

const DealerRankings = ({match, dealers}) => (
    <div className="dealerRankings">

        <Helmet>
            <title>Dealer Rankings | MarketAxess</title>
        </Helmet>

        <div className="dealerRankings__wrapper container">

            <DealerRankingsSidebar dealers={dealers} match={match}/>

            <main className="dealerRankings__main">
                <Switch>
                    {getRoutes(match, dealers)}
                </Switch>

                <div className="dealerRankings__disclaimer">
                    <p><strong>Proprietary information for MarketAxess Clients only.</strong></p>
                    <p>Note: Rankings updated by the 5th business day of each month.</p>
                </div>
            </main>

        </div>

    </div>
);


DealerRankings.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    match: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    dealers: PropTypes.array.isRequired
};

export default withRouter(DealerRankings);



// WEBPACK FOOTER //
// ./frontend/pages/DealerRankings/DealerRankings.jsx